import UserTypes from "./users.types";
import {addItemToCart, removeItemFromCart} from "./users.utils";

const INIT_STATE = {
    product : [],
    location : '',
};

const UserReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case UserTypes.ADD_PRODUCT:
            return{
                ...state,
                product: addItemToCart(state.product, action.payload)
            };
        case UserTypes.CLEAR_PRODUCT:
            return{
                ...state,
                product: state.product.filter(item => item.id !== action.payload.id)
            };
        case UserTypes.REMOVE_PRODUCT:
            return {
                ...state,
                product: removeItemFromCart(state.product , action.payload)
            };
        case UserTypes.GET_LOCATION:
            return {
                ...state,
                location: action.payload
            };
        case UserTypes.DESTROY_PRODUCT:
            return {
                ...state,
                product: []
            };
        default :
            return state
    }
}

export default UserReducer;